import { ProcedureInstanceBase } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { ParameterType, ParameterSubjectType } from "@/types/parameterTypes";
import { useState, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { ConfigurationDetails } from "../requirements/ConfigurationDetails";
import { Route } from "lucide-react";
import { Link } from "react-router-dom";

export function GeneratedProcedure(props: { procedure: ProcedureInstanceBase, children?: React.ReactNode }) {
  const { procedure, children } = props;
  const readParameters = useParameterStore(state => state.getParametersForSubject);
  const parameters = useParameterStore(useShallow(state => state.parametersForSubjectAndType(procedure.id, ParameterType.CONFIG).filter(p => !p.viewOnly)));
  const [showConfig, setShowConfig] = useState(true);

  useEffect(() => {
    void readParameters(procedure.id, ParameterSubjectType.PROCEDURE);
  }, [procedure.id]);

  return (
    <div className="generated-procedure-card-item">
      <div className="generated-procedure-card-item-header">
        <Route size={24} color="var(--neutral-500)" />
        <div className="list-card-item-info">
          <Link to={`/procedures/${procedure.projectId}/${procedure.id}/procedureProductPage`} className="list-card-item-name">{procedure.title}</Link>
          <div className="d-flex align-items-center gap-2">
            {procedure.createdAt && <span className="list-card-item-detail">{`${I18n.get('generated')} ${new Date(procedure.createdAt).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}`}</span>}
            {parameters.length > 0 && (
              <button
                className="config-toggle-link"
                onClick={() => setShowConfig(prev => !prev)}
              >
                {showConfig ? I18n.get('hideConfiguration') : I18n.get('showConfiguration')}
              </button>
            )}
          </div>
        </div>
        {children}
      </div>
      {showConfig && parameters.length > 0 && <ConfigurationDetails parameters={parameters} />}
    </div>
  );
}
